const APPLE_USER_AGENT_RE = /Mac|iPhone|iPad|iPod/

export function isAppleUserAgent(userAgent: string): boolean {
  return APPLE_USER_AGENT_RE.test(userAgent)
}

/** Raccourcis clavier Apple (⌘) - `navigator.platform` est déprécié, on lit le user-agent. */
export function isApplePlatform(): boolean {
  if (!import.meta.client) {
    return false
  }
  return isAppleUserAgent(navigator.userAgent)
}
